export const MessageChannelOptions = {
  GroupMessage: 'Create channel',
  MassMessage: 'Mass direct message',
};

export const MAX_CHARACTERS_LIMIT = 5000;
export const MAX_CHARACTERS_LIMIT_ERROR =
  'You have reached the 5000 character limit';
